import { Module } from "vuex";
import { RootState } from "../../types";
import { actions } from "./router.actions";

const namespaced: boolean = true;
export const RouterModule: Module<any, RootState> = {
  namespaced,
  actions
};
